import { Flex } from '@/components/ui/flex'
import { Text } from '@/components/ui/typography'
import useColorModeValue from '@/hooks/useColorModeValue'

const Status = ({ icon, text }: { icon?: JSX.Element | null; text: string }) => {
    return (
        <Flex alignItems="center">
            {icon && icon}
            <Text
                pl={icon ? '8px' : ''}
                fontSize="14px"
                lineHeight="20px"
                color={useColorModeValue('rgba(84, 79, 64, 0.7)', 'rgba(255, 255, 255, 0.7)')}
            >
                {text}
            </Text>
        </Flex>
    )
}

export default Status
